<template>
  <base-nav :show-toggle-button="false" class="navbar-top navbar-dark" expand id="navbar-main">
    <ul class="navbar-nav align-items-center d-none d-md-flex ml-lg-auto">
      <li class="nav-item dropdown" style="cursor: pointer">
        <base-dropdown class="nav-link pr-0">
          <div class="media align-items-center" slot="title">
            <span class="avatar avatar-sm rounded-circle">
              <img :src="this.user.image" alt="Image placeholder">
            </span>
            <div class="media-body ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm font-weight-bold text-white">{{ this.user.email }}</span>
              <!--<i class="ni ni-bold-down"></i>-->
              <i class="fas fa-caret-down" style="margin-left: 0.5rem"></i>
            </div>
          </div>

          <template>
            <div class=" dropdown-header noti-title">
              <h6 class="text-overflow m-0">Willkommen!</h6>
            </div>
            <router-link class="dropdown-item" to="/profile">
              <i class="ni ni-single-02"></i>
              <span>Profil</span>
            </router-link>
            <div class="dropdown-divider"></div>
            <router-link class="dropdown-item" to="#">
              <i class="ni ni-user-run"></i>
              <span @click="logoutUser">Abmelden</span>
            </router-link>
          </template>
        </base-dropdown>
      </li>
    </ul>
  </base-nav>
</template>
<script>
  import * as firebase from 'firebase'
  import 'firebase/auth'
  import { mapState } from "vuex";
  import store from "../store";

  export default {
    computed: {
      ...mapState({
        user: state => state.user,
      })
    },
    data() {
      return {
        activeNotifications: false,
        showMenu: false,
        searchQuery: '',
      };
    },
    methods: {
      logoutUser() {
        firebase.auth().signOut().then(() => {
          store.commit('removeUser');
          this.$router.replace({ name: "login" });
        });
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      }
    }
  };
</script>

<style scoped>
</style>
